import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import KioskIcon from 'theme/modes/kiosk.svg'

export const Kiosk:React.FC<SvgIconProps> = (props) => <SvgIcon {...props}>
  <KioskIcon />
</SvgIcon>

export default Kiosk
